import React from 'react';
import { graphql } from 'gatsby';
import Col from '../../primitives/grid/col';
import Row from '../../primitives/grid/row';
import NotchedSlider, { NotchedSliderInstance } from '../../primitives/notched-slider';
import Pagination from '../../primitives/notched-slider/pagination';
import { SliderLeftButton, SliderRightButton } from '../../primitives/notched-slider/slider-buttons';
import { breakpoints } from '../../primitives/tokens';
import Typography from '../../primitives/typography';
import Container from '../../primitives/grid/container';
import paddingDefault from '../../utils/padding-default';

const TestimonialsSlider: React.FC<Queries.TestimonialsSliderDataFragment> = (data): JSX.Element => {
    const { slides } = data;

    return (
        <NotchedSlider slideCount={(slides || []).length}>
            <section css={paddingDefault()}>
                <NotchedSliderInstance slidesPerView={{
                    dt: 1,
                }}
                >
                    <Container>
                        <Row>
                            <Col
                                breakpoints={{
                                    dt: { span: 1 },
                                    mb: { hidden: true, span: 1 },
                                }}
                                css={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                            >
                                <SliderLeftButton />
                            </Col>
                            <Col breakpoints={{
                                dt: { span: 10 },
                                mb: { span: 4 },
                            }}
                            >
                                <NotchedSlider.Slides masksLeft masksRight>
                                    {(slides || []).map((slide) => {
                                        if (!slide) return null;
                                        const {
                                            authorName: fullName,
                                            authorCompany: job,
                                            quote,
                                        } = slide;
                                        return (
                                            <div key={fullName} css={{ paddingBottom: '32px' }}>
                                                <div css={{
                                                    marginBottom: '32px',
                                                    [breakpoints.mb]: {
                                                        marginBottom: '16px',
                                                    },
                                                }}
                                                >
                                                    <Typography fontSize={{
                                                        dt: 'lg',
                                                        tb: 'base',
                                                    }}
                                                    >
                                                        {fullName}
                                                    </Typography>
                                                    <Typography
                                                        fontSize={{
                                                            dt: 'base',
                                                            tb: 'sm',
                                                        }}
                                                        css={{ opacity: 0.7 }}
                                                    >
                                                        {job}
                                                    </Typography>
                                                </div>
                                                <Typography
                                                    fontSize={{
                                                        dt: '3xl',
                                                        tb: '2xl',
                                                        mb: 'xl',
                                                    }}
                                                    color="primaryOrange"
                                                >
                                                    {quote}
                                                </Typography>
                                            </div>
                                        );
                                    })}
                                </NotchedSlider.Slides>
                                {slides && (
                                    <Pagination css={{ justifyContent: 'flex-start' }} small />
                                )}
                            </Col>
                            <Col
                                breakpoints={{
                                    dt: { span: 1 },
                                    mb: { hidden: true, span: 1 },
                                }}
                                css={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                            >
                                <SliderRightButton />
                            </Col>
                        </Row>
                    </Container>
                </NotchedSliderInstance>
            </section>
        </NotchedSlider>
    );
};

export default TestimonialsSlider;

export const query = graphql`
    fragment TestimonialsSliderData on CsTestimonialsGroup {
        slides {
            authorName
            authorCompany
            quote
            image {
                filename
                title
                url
                contentStackAsset(size: HALF_MAX_WIDTH)
            }
        }
    }
`;
